import {Injectable} from '@angular/core';
import {BaseDaoService, ChangesStatus, ChangesType, handleError} from '@q9elements/ui-kit/common';

import {BulkOperationsResponse} from '../models/bulk-operations';

@Injectable({providedIn: 'root'})
export class ChangesBulkOperationsDaoService extends BaseDaoService {
  updateFields(itemType: ChangesType, data: Record<string, any>) {
    return this.http
      .post<BulkOperationsResponse>(`${this.apiUrl}/${itemType}/bulk`, data)
      .pipe(handleError());
  }

  getStatusListForBulk(itemType: ChangesType) {
    return this.http
      .get<Partial<ChangesStatus>>(`${this.apiUrl}/${itemType}/bulk/status`)
      .pipe(handleError());
  }

  validateStatus(itemType: ChangesType, items: string[], status: string) {
    return this.http
      .post<number>(`${this.apiUrl}/${itemType}/bulk/status`, {
        items,
        payload: {status}
      })
      .pipe(handleError());
  }

  updateStatus(itemType: ChangesType, data: {status: string; reason: string}) {
    return this.http
      .put<BulkOperationsResponse>(`${this.apiUrl}/${itemType}/bulk/status`, data)
      .pipe(handleError());
  }

  getAndValidateItemsSendToJira(itemType: ChangesType, itemIds: string[]) {
    return this.http
      .post<string[]>(`${this.apiUrl}/integrations/jira/bulk/${itemType}`, {itemIds})
      .pipe(handleError());
  }

  sendItemsToJira(itemType: ChangesType, payload: Record<string, string[]>) {
    return this.http
      .put(`${this.apiUrl}/integrations/jira/bulk/${itemType}`, {payload})
      .pipe(handleError());
  }
}
